// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".DN58FuMi6OEIuUFDkHkR{position:relative}.DN58FuMi6OEIuUFDkHkR.awDuX9PHzR7MhNU8jlkt{display:inline-flex;width:100%}", "",{"version":3,"sources":["webpack://./src/components/Message/BrainResponseEvent/BrainResponseEvent.module.scss"],"names":[],"mappings":"AAAA,sBACE,iBAAA,CAEA,2CACE,mBAAA,CACA,UAAA","sourcesContent":[".brainMessageContainer {\n  position: relative;\n\n  &.showFeedBackBubble {\n    display: inline-flex;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brainMessageContainer": "DN58FuMi6OEIuUFDkHkR",
	"showFeedBackBubble": "awDuX9PHzR7MhNU8jlkt"
};
export default ___CSS_LOADER_EXPORT___;
